import PropTypes from 'prop-types'
import React from 'react'
import { ThCell } from '../../../../../common/table/ThCell'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { SelectCell } from './SelectCell'

export const MultiTHead = ({
  tableTitle,
  tabName,
  onChangeAuditStatus,
  onChangeMethod,
}) => {
  const tableTitleHeader =
    tabName === 'cashFlows' ? tableTitle : tableTitle.slice(0, 3)

  return (
    <>
      {tableTitleHeader.map((row, rowIndex) => {
        return (
          <tr key={rowIndex}>
            {row.map((col, colIndex) => {
              const result =
                rowIndex !== 1
                  ? {
                      title: col.title,
                      colId: col.colId,
                      isI18n: true,
                    }
                  : {
                      title: col.title,
                      colId: col.colId,
                      isI18n: true,
                      renderTh: () => {
                        return (
                          <TextEllipsisStaticLine
                            zIndexTooltip={7}
                            text={col.title || ''}
                            isI18n={true}
                            lineClamp={1}
                          />
                        )
                      },
                    }
              return (
                <React.Fragment key={colIndex}>
                  {colIndex === 0 || !col.selectData ? (
                    <ThCell
                      style={{
                        fontWeight: colIndex === 0 ? 600 : 400,
                        fontSize: colIndex === 0 ? 14 : 12,
                        backgroundColor: '#E5E5E8',
                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        borderBottomColor: ' #ffffff',
                        textAlign: 'left',
                        position: col.isSticky ? 'sticky' : '',
                        top: col.isSticky ? 0 : '',
                        zIndex: col.isSticky ? 1 : '',
                      }}
                      col={{
                        ...result,
                        thStyle: {
                          justifyContent:
                            colIndex === 0 ? 'flex-start' : 'flex-end',
                        },
                      }}
                      isNoStickyHead={true}
                    />
                  ) : (
                    <SelectCell
                      chooseItem={
                        col?.rowName === 'method'
                          ? onChangeMethod
                          : onChangeAuditStatus
                      }
                      data={col.selectData}
                      title={{
                        label: result.title,
                        value: col.selectData.find(
                          (data) => data.label === result?.title,
                        )?.value,
                      }}
                      year={col.year}
                    />
                  )}
                </React.Fragment>
              )
            })}
          </tr>
        )
      })}
    </>
  )
}

MultiTHead.propTypes = {
  tableTitle: PropTypes.array.isRequired,
  tabName: PropTypes.string,
  onChangeAuditStatus: PropTypes.func,
  onChangeMethod: PropTypes.func,
}
